import { render, staticRenderFns } from "./points_account_record_list.vue?vue&type=template&id=160a512a&scoped=true"
import script from "./points_account_record_list.vue?vue&type=script&lang=js"
export * from "./points_account_record_list.vue?vue&type=script&lang=js"
import style0 from "./points_account_record_list.vue?vue&type=style&index=0&id=160a512a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160a512a",
  null
  
)

export default component.exports